import React, {FC} from "react";
import {Card} from "react-bootstrap";
import {Field} from "formik";
import {FormikRowInput, FormikRowCheckbox} from "@components/panel/formik";
import {GoalRewardType} from "@interfaces/consumer/refs";

export interface GoalRewardFormValues {
    name: string;
    order: number;
    isActive: boolean;
    type: GoalRewardType;
    balance?: number;
    itemId?: string;
    count?: number;
}

interface RewardBaseInfoBlockProps {
    editForm?: boolean;
}

const RewardBaseInfoBlock: FC<RewardBaseInfoBlockProps> = ({editForm}) => {
    return (
        <Card className="mb-3">
            <Card.Header as="h6" className="bg-body-tertiary">Основное</Card.Header>
            <Card.Body>
                <Field
                    label="Название"
                    name="name"
                    component={FormikRowInput}
                />

                {editForm && (
                    <>
                        <Field
                            label="Активно"
                            name="isActive"
                            type="switch"
                            id="reward-active"
                            component={FormikRowCheckbox}
                        />

                        <Field
                            label="Порядковый номер"
                            name="order"
                            type="number"
                            component={FormikRowInput}
                        />
                    </>
                )}
            </Card.Body>
        </Card>
    );
};

export default RewardBaseInfoBlock;
